const scrollFrames = {
    defaults: {
        style: {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
        }
    },

    getIntersection(el) {
        let response = -1;
        if (typeof el === 'object') {
            const box = el.getBoundingClientRect();
            const el_offset_top = box.top + window.pageYOffset - document.documentElement.clientTop;
            const el_height = el.clientHeight;
            const window_scroll_top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
            const window_height = window.document.documentElement.clientHeight;
            response = (window_scroll_top + window_height - el_offset_top) / (window_height + el_height);
        }
        // Limit between 0 and 1
        response = Math.max(0, Math.min(1, response));
        return response;
    },

    anims: {},

    update() {
        let elems = document.querySelectorAll('[scroll-frames]');
        if (!elems) return;

        elems.forEach(el_anim => {
            const anim_id = el_anim.getAttribute('scroll-frames');
            const anim_url_mask = el_anim.dataset.urlMask;
            const anim_keyframes = el_anim.dataset.keyframes || '0:0 to 100:100';

            if (anim_id && anim_url_mask) {
                const anim_mask_array = anim_url_mask.split('|');
                if (anim_mask_array.length === 3) {
                    const anim_mask_interval = anim_mask_array[1].split(' to ');
                    const anim_mask_i_start = parseInt(anim_mask_interval[0]);
                    const anim_mask_i_end = parseInt(anim_mask_interval[1]);
                    let json_from_mask = [];

                    for (let frame_index = anim_mask_i_start; frame_index <= anim_mask_i_end; frame_index++) {
                        json_from_mask.push({
                            url: anim_mask_array[0] + frame_index + anim_mask_array[2]
                        });
                    }

                    // ✅ Double the sequence for smooth infinite feel
                    json_from_mask = [...json_from_mask, ...json_from_mask];

                    scrollFrames.build(json_from_mask, el_anim, anim_id, anim_keyframes);
                }
            }
        });
    },

    build(json, el_anim, anim_id, anim_keyframes) {
        const backgroundImage = json.map(d => `url(${d.url})`).join(',');
        const backgroundSizes = json.map((_, i) =>
            json.map((__, j) => (i === j ? 'contain' : '0%')).join(',')
        );

        scrollFrames.anims[anim_id] = {
            ready: true,
            el: el_anim,
            backgroundImage: backgroundImage,
            backgroundSizes: backgroundSizes,
            transfer(scroll_line) {
                let response = scroll_line;
                if (anim_keyframes.indexOf(':') > 0) {
                    const fromToArray = anim_keyframes.split(' to ');
                    let xa = 0, ya = parseFloat(fromToArray[0].split(':')[1]);
                    let xb = 1, yb = 1;

                    fromToArray.forEach((keypoint, i) => {
                        if (i < fromToArray.length - 1) {
                            const positionCurrent = parseFloat(keypoint.split(':')[0]) / 100;
                            const positionNext = parseFloat(fromToArray[i + 1].split(':')[0]) / 100;
                            if (scroll_line >= positionCurrent && scroll_line <= positionNext) {
                                xa = positionCurrent;
                                ya = parseFloat(keypoint.split(':')[1]);
                                xb = positionNext;
                                yb = parseFloat(fromToArray[i + 1].split(':')[1]);
                            }
                        }
                    });
                    const coef = (yb - ya) / (xb - xa);
                    const y0 = yb - coef * xb;
                    response = (coef * scroll_line + y0) / 100;
                }
                return response;
            }
        };

        el_anim.style.backgroundImage = backgroundImage;
        Object.keys(scrollFrames.defaults.style).forEach(prop => {
            el_anim.style[prop] = scrollFrames.defaults.style[prop];
        });

        scrollFrames.frame();
        window.addEventListener('scroll', scrollFrames.raf);
    },

    raf() {
        window.requestAnimationFrame(scrollFrames.frame);
    },

    frame() {
        Object.keys(scrollFrames.anims).forEach(anim_id => {
            const anim = scrollFrames.anims[anim_id];
            if (!anim.ready || !anim.el) return;

            const scrollLine = scrollFrames.getIntersection(anim.el);
            const frameProgress = anim.transfer(scrollLine);

            // 🔁 Infinite looping fix
            const totalFrames = anim.backgroundSizes.length;
const frameIndex = Math.floor(((1 - frameProgress) * totalFrames) % totalFrames);

            anim.el.style.backgroundSize = anim.backgroundSizes[frameIndex];
        });
    }
};

scrollFrames.update();